// Canvas libraries (Chart.js) need real colors, not "var(--app-c1)" or light-dark().
// The browser resolves them on a hidden element that inherits the page color-scheme.
export function cssColor(value: string): string {
  if (typeof document == 'undefined' || !document.body) return value;

  const probe = document.createElement('span');
  probe.style.display = 'none';
  probe.style.color = value;
  document.body.appendChild(probe);
  const color = getComputedStyle(probe).color;
  probe.remove();
  return color || value;
}
